/* global localStorage */

import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URI || 'http://localhost:3000/api/v1'
var token = localStorage.getItem('shareXToken')
export default axios.create({
  baseURL: API_URL,
  headers: {
		'Content-Type': 'application/json',
		'Authorization': `Bearer ${localStorage.getItem('shareXToken')}`
  }
})
